export default async function copyText(str: string | null | undefined) {
  if (!str) return Promise.reject(null);
  return await navigator?.clipboard?.writeText?.(str);
}
